import React, { useState, useEffect } from 'react';
import UserInfo from './UserInfo';
import { apiCall } from '../apiclient';
import { DropdownButton, Dropdown } from 'react-bootstrap';
import UserList from './UserList';
import { User } from '../classes/User';

export default function UserAdmin(props) {

    const [selectedUser, setSelectedUser ] =
        useState(null);
    
    // var userList = [];

    // console.log("UserAdmin() start: " + JSON.stringify(selectedUser));

    function selectUser(u) {
        var usr = new User(u);
        // console.log("selectedUser(): " + JSON.stringify(usr));
        setSelectedUser(usr);
        // console.log("now: " + JSON.stringify(selectedUser));
    }

    function selectedUserInfo () {
        // console.log("selectedUserInfo(): " + JSON.stringify(selectedUser));
        if(selectedUser != null) {
            return(
                <UserInfo user={selectedUser} updateUser={(u) => {}}adminAccess={true} title="User Info" />
            );
            } else {
                return(null);
            }
        }
    // console.log("UserAdmin() returning")
    return(
        <div>
        <UserList user={props.user} updateUser={props.updateUser} 
                selectUser={(u) => selectUser(u)} />
        {selectedUserInfo()}
        </div>
    )
}